import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AssetUIModel, ClientCoreModule, FormField, ValueListsService } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { vkbGeneralInformationFields } from './../../../../../../../../customer/vkb/vkb-form-fields';
@Component({
  selector: 'thehubz-vkb-asset-metadata',
  templateUrl: './vkb-asset-metadata.component.html',
  styleUrls: ['./vkb-asset-metadata.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ClientCoreModule, MatTooltipModule],
})
export class VKBAssetMetadataComponent implements OnInit {
  @Input() asset!: AssetUIModel;
  assetFieldObject: AnyType = [];
  constructor(protected valueListsService: ValueListsService) {}
  ngOnInit(): void {
    this.assetFieldObject = [...vkbGeneralInformationFields()];
    const statusFieldIndex = this.assetFieldObject.findIndex((fields: FormField) => fields.formFieldName === 'status');
    if (statusFieldIndex > -1) {
      const mediaTypeField: FormField = this.assetFieldObject[statusFieldIndex];
      mediaTypeField.options.push({ _id: Asset.StatusEnum.Expired, name: $localize`Expired` });
    }
  }
}
